import pixAxios from '@/axios/pixAxios.js';

export default {
  searchDocuments: async (params) => {
    return pixAxios.post('/api/Document/SearchDocuments', params);
  },
};
